import { Component, OnDestroy, OnInit } from '@angular/core';
import { ContentService, TypableService } from '../_core';
import { LcpHelper } from '../_core/_helpers/lcp-helper';
import { Router } from '@angular/router';


// animations inspired by: 
// https://www.youtube.com/watch?v=HSxQbGXDo3U&ab_channel=BrianTreese
// https://stackblitz.com/edit/stackblitz-starters-3ufzct?file=src%2Fsign-up-form%2Fsign-up-form.component.ts

@Component({
  selector: 'lcp-services',
  templateUrl: './services.component.html',
  styleUrls: ['./services.component.scss'],
})
export class ServicesComponent implements OnInit, OnDestroy {

  slug = 'services'
  content: any
  fields: any

  hoveringServiceIndex: number

  typableIntersectionObserver: any

  metadataSlugs = [
    'services-page-service-description-length-max',
    'learn-more-arrow-1'
  ]
  metadata: any = {}
  descriptionPlaceholder: string
  learnMoreArrowMedia: any

  constructor(
    private router: Router,
    public contentService: ContentService,
    public lcpHelper: LcpHelper,
    public typableService: TypableService
  ) { }

  ngOnInit(): void {
    this.getMetadata()
    this.getPage()
  }

  ngOnDestroy(): void {
  }

  initIntersectionObservers() {
    const mobileWrappers = document.getElementsByClassName('typable-wrapper-mobile')
    if (!mobileWrappers) return console.log('!mobileWrappers')
    const mobileWrappersArray = Array.prototype.slice.call( mobileWrappers )

    for (const [i, el] of mobileWrappersArray.entries()) {      
      const mobileServiceElement = el.querySelector('.typable-container')
      // console.log('CHECK mobileServiceElements', mobileServiceElement)
      const block = this.fields['sections'][0].fields['items'][i]
      if (!block) console.log('ERR: initIntersectionObserver !block')
      this.typableIntersectionObserver = this.typableService.initIntersectionObserver(mobileServiceElement, { block: block })
    }
  }

  getMetadata() {
    this.contentService.getMetadata({'fields.slug[in]': this.metadataSlugs.join(',') }) // { slug: 'scroll-arrow-icon' })
    .subscribe({
      next: (meta: any) => {
        try {
          if (!meta.items[0]) return console.log('ERR: !meta', meta)
          
          for (let item of meta.items) {
            let val
            switch (item.fields['type']) {
              case 'other':
              case 'string': val = item.fields['value']; break;
              case 'number': val = +item.fields['value']; break;
              case 'media': val = item.fields['media']; break;
              case 'items': val = item.fields['items']; break;
            }
            this.metadata[item.fields['slug']] = val // NOTE: ALL NUMBERS this time
          }
          const descriptionPlaceholderArray = Array(this.metadata['service-page-category-description-length-max']).fill('x')
          this.descriptionPlaceholder = descriptionPlaceholderArray.join('')
          this.learnMoreArrowMedia = this.metadata['learn-more-arrow-1'][0]
          // console.log('CHECK: meta', meta, this.learnMoreArrowMedia, this.metadata) // this.descriptionPlaceholder, this.metadata)
        } catch {
          console.log('ERR: getMetadata', meta)
        }
      }
    })
  }

  getPage(){
    this.contentService.getPage({ 'fields.slug': this.slug })
    .subscribe({
      next: (content) => {
        this.content = content
        if (!this.content) return console.log('!content', this.content)
        this.fields = this.content.items[0].fields
        // console.log('fields', this.fields)
        window.setTimeout(() => {
          this.initIntersectionObservers()
        }, 500)
      }
    });
  }

  async handleHoverService(params={}) {
    if (this.hoveringServiceIndex == params['index']) return // console.log('isHoveringServiceIndex', this.hoveringServiceIndex, params['index'])
    this.hoveringServiceIndex = params['index']

    this.typableService.typeText(params)
  } 


  handleBlurService(params={}) {
    window.setTimeout(() => { if (this.hoveringServiceIndex == params['index']) this.hoveringServiceIndex = null }, 1)

    const evt = params['event']
    if (!evt) console.log('ERR: handleBlurService !evt', params)
    const typableTextElement = this.typableService.typableTextElementWithinContainer(evt && evt.target)
    if (!typableTextElement) return console.log('ERR: !typableTextElement')
    
    this.lcpHelper.stopTypingElement(typableTextElement)
    typableTextElement.classList.remove('is-typed')
    
    console.log('TODO: reimplement blur remove text')
    // typableTextElement.innerHTML = null


    // console.log('TODO: handleBlurService', params)
  }

  handleSelectService(block) {
    // console.log('TODO: handleSelectService', block)
    const link = this.lcpHelper.linkFromBlock(block)
    if (!link) return
    this.router.navigate([link.address])
  }
}
